export class LoginModel {
   userName: string;
   password: number;
}
